<label [for]="inputId" [class]="labelClass" [class.required]="required">{{ label }}</label>
<input
	#addressInput
	type="text"
	class="form-control"
	autocomplete="off"
	[id]="inputId"
	[name]="inputId"
	[(ngModel)]="query"
	(ngModelChange)="onQueryChange($event)"
	[ngModelOptions]="{ standalone: true }"
	[disabled]="disabled"
	[readonly]="isExpanding"
	(blur)="stopExpanding()"
	(keydown.escape)="stopExpanding()"
	[typeahead]="dataSource"
	[typeaheadAsync]="true"
	typeaheadOptionField="typeaheadLabel"
	(typeaheadLoading)="loading = $event"
	[isAnimated]="true"
	[typeaheadWaitMs]="400"
	[typeaheadMinLength]="minLength"
	[typeaheadScrollable]="true"
	[typeaheadOptionsInScrollableView]="10"
	[optionsListTemplate]="addressListTpl"
	(typeaheadOnSelect)="onSelect($event)"
	placeholder="Start typing here..." />
<ng-template #addressListTpl let-matches="matches" let-typeaheadTemplateMethods>
	@for (match of matches; track match) {
		<button
			type="button"
			class="dropdown-item"
			[class.active]="typeaheadTemplateMethods.isActive(match)"
			(click)="typeaheadTemplateMethods.selectMatch(match, $event)"
			(mouseenter)="typeaheadTemplateMethods.selectActive(match)">
			{{ match.item.typeaheadLabel }}
		</button>
	}
</ng-template>
<pk-broker-loader [show]="loading"></pk-broker-loader>
<p class="mb-1 helper-text">{{ helperText }}</p>
@if (invalid) {
	<div class="invalid-feedback d-block">{{ invalidText }}</div>
}
@if (showNoMatch) {
	<div class="invalid-feedback d-block">No addresses matched "{{ query }}".</div>
}
@if (allowManualEntry) {
	<p class="mb-1 helper-text">Can't find your address? <a href="javascript:void(0)" (click)="manualEntry.emit()">Enter Manually</a></p>
}
